import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

interface CargoTableProps {
  rows: any[];
  columns: GridColDef[];
  height?: number;
  width?: string;
}

const CargoTable: React.FC<CargoTableProps> = ({
  rows,
  columns,
  height = 350,
  width = '100%',
}) => {
  return (
    <div style={{ height, width }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSizeOptions={[5, 10, 20, 100]}
        pagination
        checkboxSelection={false}
        disableRowSelectionOnClick
        getRowClassName={(params) => {
          const fromValue = params.row.fromIdentification;
          const rowIndex = params.indexRelativeToCurrentPage; 

          if (fromValue === 'LAX') {
            return rowIndex % 2 === 0 ? 'highlight-lax-even' : 'highlight-lax-odd';
          }
          if (fromValue === 'CVG') {
            return rowIndex % 2 === 0 ? 'highlight-cvg-even' : 'highlight-cvg-odd';
          }
          if (fromValue === 'DFW') {
            return rowIndex % 2 === 0 ? 'highlight-dfw-even' : 'highlight-dfw-odd';
          }
          if (fromValue === 'MIA') {
            return rowIndex % 2 === 0 ? 'highlight-mia-even' : 'highlight-mia-odd';
          }

          return '';
        }}
        sx={{
          '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-row:nth-of-type(odd)': {
            backgroundColor: 'white',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#b2d1ff',
          },
          '& .highlight-lax-even': {
            backgroundColor: '#2600A0 !important',
            color: '#FFFFFF !important',
          },
          '& .highlight-lax-odd': {
            backgroundColor: '#0004B9 !important',
            color: '#FFFFFF !important',
          },

          '& .highlight-cvg-even': {
            backgroundColor: '#89E17E !important',
          },
          '& .highlight-cvg-odd': {
            backgroundColor: '#B1EEB6 !important',
          },
          '& .highlight-dfw-even': {
            backgroundColor: '#fff1c1 !important',
          },
          '& .highlight-dfw-odd': {
            backgroundColor: '#fff7a8 !important',
          },

          '& .highlight-mia-even': {
            backgroundColor: '#C6C3BE !important',
          },
          '& .highlight-mia-odd': {
            backgroundColor: '#FFFCF8 !important',
          },
          '& .MuiTablePagination-selectLabel': {
            marginTop: '14px',
          },
          '& .MuiTablePagination-displayedRows': {
            marginTop: '14px',
          },
          "& .MuiDataGrid-cell[id='id']": {
          cursor: 'pointer !important',
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
            outline: "none",
          }
        }}
      />
    </div>
  );
};

export default CargoTable;
